import { FiltersListProps } from "types/filters";
import { FiltersToApplyOnCampaignsPage } from "containers/admin/clients/client/campaigns-page/components/filters-on-campaigns-table/filters-on-campaigns-table.types";

export const CAMPAIGNS_TABLE_FILTERS_DATA: FiltersListProps[] = [
  {
    title: "Program type",
    filterId: "programType",
    options: [],
  },
  {
    title: "Campaign objective",
    filterId: "campaignObjective",
    options: [],
  },
  {
    title: "Audience",
    filterId: "audience",
    options: [],
  },
];

export const FILTER_ID_TO_TITLE: Record<string, string> = {
  programType: "Program type",
  campaignObjective: "Campaign objective",
  audience: "Audience",
};

export const DEFAULT_CAMPAIGNS_FILTERS_TO_APPLY: FiltersToApplyOnCampaignsPage = {
  programType: [],
  campaignObjective: [],
  audience: [],
};
